define('home/templates/discussionCreateToolbar',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"input--formatting-region\">\n<span data-role=\"formatting-buttons\"></span>\n<span data-role=\"upload-button\"></span>\n</div>\n\n<div class=\"align__item hidden-md\">\n<button data-action=\"show-formatting\" type=\"button\" class=\"button text-smaller link-gray\">\n<span class=\"icon-formatting\">A</span>\n"
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Formatting Help",{"name":"gettext","hash":{},"data":data}))
    + "\n</button>\n</div>\n";
},"useData":true})

});
